import React, { useContext } from 'react';
import RoundButton from '../../../../../components/RoundButton';
import { Context } from '../../../../../context/AppContext';
import { MODALS } from '../../../../../constants';
import { ShareIcon } from '../../../../../assets/share';
import './styles.css';

const Share = ({ name, url, phone, suburb, state, text }) => {
  const {
    modal: { showModal },
  } = useContext(Context);
  return (
    <RoundButton
      icon={<img src={ShareIcon} alt="profile share" />}
      size="smaller"
      theme="outlineLightGrey"
      className="Listview__Card__share"
      type="button"
      onClick={() =>
        showModal(MODALS.SHARE, {
          name,
          url,
          phone,
          suburb,
          state,
        })
      }
    >
      {text}
    </RoundButton>
  );
};

export default Share;
